@use "../../variables" as *;

.input {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  box-sizing: border-box;
  width: 100%;
  outline: none;
  font-size: 1.125rem;
  padding: 1rem;
  border: 1px solid $grey;
  color: $grey;
  font-weight: 300;

  &:hover,
  &:focus {
    border: 1px solid $grey;
  }

  &::placeholder {
    color: $grey-light;
  }

  &:placeholder-shown {
    border: 1px solid $grey-lighter;
  }

  &:hover:placeholder-shown,
  &:focus:placeholder-shown {
    border: 1px solid $grey;

    &::placeholder {
      color: $grey;
    }
  }
}